import { render } from "./8-nights.vue?vue&type=template&id=444a49fd&scoped=true"
import script from "./8-nights.vue?vue&type=script&lang=js"
export * from "./8-nights.vue?vue&type=script&lang=js"

import "./8-nights.vue?vue&type=style&index=0&id=444a49fd&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444a49fd"]])

export default __exports__